import { Component, OnDestroy, OnInit } from '@angular/core';
import {CellComponent} from '@shared/components/cell-components/cell-component';
import {FieldDefinition} from '@shared/models/field-definition';

@Component({
    standalone: false,
    selector: 'app-response-days-available-cell-viewer',
  templateUrl: './response-days-available-cell-viewer.component.html',
  styleUrls: ['./response-days-available-cell-viewer.component.scss']
})
export class ResponseDaysAvailableCellViewerComponent implements OnInit, CellComponent {

  fieldDefinition: FieldDefinition;
  item: any;
  responseDaysAvailable = '';
  constructor() { }

  ngOnInit(): void {
    if (this.item.cells['ResponseDueDate'] && this.item.cells['ResponseDueDate'].value) {
      if (this.item.cells['ActuallySubmittedDate'] && this.item.cells['ActuallySubmittedDate'].value) {
        this.responseDaysAvailable = 'Completed';
      } else {
        const responseDueDate = new Date(this.item.cells['ResponseDueDate'].value);
        // add offset to the utc time to convert as local time with same value
        responseDueDate.setMinutes(responseDueDate.getMinutes() + responseDueDate.getTimezoneOffset());
        const currentDate = new Date();
        // reset current local date
        currentDate.setHours(0, 0, 0, 0);

        // console.log('Resoponse Due Date: ', this.item.cells['ResponseDueDate'].value, 'Updated ', responseDueDate, 'Current ', currentDate);
        // console.log('Current Date: ', currentDate);

        const difference = responseDueDate.getTime() - currentDate.getTime();
        const days =  Math.ceil(difference / (1000 * 3600 * 24));

        if (days < 0) {
          this.responseDaysAvailable = `${days * -1} day${(days === -1 ? '' : 's')} overdue`;
        } else {
          this.responseDaysAvailable = `${days}`;
        }
      }
    }

  }



}
